import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { AppContext } from "@/shared/context/context";
import signalRMessages from "@/redux/actions/signalRMessages";
import useNotification from "@/shared/hooks/UseNotification";
import useSocketEvent from "@/shared/hooks/useSocketEvent";

const useGlobalMeetingVotingBallotGenerationMessages = () => {
    const { t } = useTranslation();
    const { sendNotification } = useNotification();
    const { currentTeamUser } = useContext(AppContext);

    useSocketEvent(
        signalRMessages.VotingBallotFileGenerationStatusCompleted,
        (meetingId: string, _: string, hoaName: string, userId: string) => {
            if (userId !== currentTeamUser?.userId) return;

            sendNotification({
                message: t('_meeting.generateVotingBallot.finishedNotification', {
                    hoaName,
                }),
                onSuccessRoute: `/meeting/${meetingId}`,
                variant: 'success',
            });
        },
    );
}

export default useGlobalMeetingVotingBallotGenerationMessages;